export default {
  rolePermissions: {},
};
